export class DeviceNameDto {
    deviceName?:string
    deviceMacId?:string
}